import React from 'react';
import Sidebar from '../sidebar';
import ProfileHeader from '../profile_header';

const Layout: React.FC<{children:React.ReactNode}> = ({ children }) => {
  return (
    <div className="flex">
      <Sidebar />
      <div className='w-full sm:px-10 px-5'>
        <ProfileHeader/>
        {children}
      </div>
    </div>
  );
};

export default Layout;
